import {
  GetAccount200ResponsePositionsInner,
  GetOrderbook200Response,
} from "../../../codegen-api";

export interface IConfirmationOverlayInfoProps {
  show: boolean;
  onClose: () => void;
  loading?: boolean;
  error?: string;

  // If orderbook data is provided, use this instead of connecting to WS
  orderbookData?: GetOrderbook200Response;
  position: GetAccount200ResponsePositionsInner;
  onClosePosition: () => void;
}

export enum LiquidityTypeEnum {
  SUFFICIENT = 0,
  BLEND,
  INSUFFICIENT,
  NONE,
}

export type IPositionInfo =
  | {
      liquidityType: LiquidityTypeEnum.SUFFICIENT;
      bestLiquidity: {
        iv?: string;
        price: string;
      };
      pnl: number;
    }
  | {
      liquidityType: LiquidityTypeEnum.BLEND | LiquidityTypeEnum.INSUFFICIENT;
      averagePrice: string;
      averageIV?: string;
      pnl: number;
      // INSUFFICIENT only: only part of the position can be filled. These
      // expose the size split so the UI can reconcile the realized loss
      // (on closed portion) against the position's overall unrealized PnL.
      closedSize?: number;
      totalSize?: number;
      remainingSize?: number;
      remainingUnrealizedPnl?: number;
    }
  | {
      liquidityType: LiquidityTypeEnum.NONE;
    };
